import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Conversation } from 'src/app/shared/models/messaging/conversation';
import { BonCommande } from 'src/app/shared/models/bonCommande';
import { ConstantsService } from '../constant/constants.service';
import { GenericCrudService } from '../generic-crud.service';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { ListingResponse } from 'src/app/shared/models/listing/listing-response';
import { HttpParams } from '@angular/common/http';

@Injectable({
	providedIn: 'root'
})
export class BonCommandeService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	importBonCommandes(file: File): Observable<ImportResponse> {
		const formData: FormData = new FormData();
		formData.append('file', file, 'bonCommandes.csv');
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.bonCommandeUrl}/import`,
			`importBonCommandes`,
			formData
		);
	}

	getAllBonCommandes(): Observable<BonCommande[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.bonCommandeUrl}/all`,
			'getAllBonCommandes'
		);
	}

	getBonCommandeByServiceAndRegion(serviceId: number, regionId: number): Observable<BonCommande[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.bonCommandeUrl}/getByServiceAndRegion/${serviceId}/${regionId}`,
			'getBonCommandeByServiceAndRegion'
		);
	}

	getBonCommandesMinimal(): Observable<BonCommande[]> {
		let queryParams = new HttpParams().append('light', true);
		const httpOptions = {
			params: queryParams
		};

		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.bonCommandeUrl}/all`,
			'getAllBonCommandes',
			httpOptions
		);
	}

	getBonCommandesPageable(
		page: number,
		size: number,
		search: string,
	): Observable<ListingResponse> {
		let queryParams = new HttpParams();
		queryParams = queryParams.append('page', page);
		queryParams = queryParams.append('size', size);
		if (search) {
			queryParams = queryParams.append('search', search);
		}

		const httpOptions = {
			params: queryParams
		};

		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.bonCommandeUrl}`,
			'getBonCommandes',
			//httpOptions
		);
	}

	getAllBonCommandesForMessaging(): Observable<BonCommande[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.messageUrl}/bonCommandes`,
			'getAllBonCommandesForMessaging'
		);
	}

	getBonCommandeById(bonCommandeId: number): Observable<BonCommande> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.bonCommandeUrl}/get/${bonCommandeId}`,
			'getBonCommandeById'
		);
	}

	addBonCommande(bonCommande: BonCommande): Observable<BonCommande> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.bonCommandeUrl}/add`,
			`addBonCommande`,
			bonCommande
		);
	}

	updateBonCommande(bonCommande: BonCommande): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.bonCommandeUrl}/update/${bonCommande.id}`,
			`updateBonCommande`,
			bonCommande
		);
	}

	deleteBonCommande(bonCommandeId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.bonCommandeUrl}/delete/${bonCommandeId}`,
			`deleteBonCommande`
		);
	}

}
